import type { MenuItemProps } from '@wix/thunderbolt-becky-types'

const slotItemWithSubItemClearance = (item: MenuItemProps) => {
	const subItems = item.items || []

	return subItems.length > 0
}

export const filterItemsWithSlot = (
	items: Array<MenuItemProps>,
	allowSlotItemWithSubItems = false
): Array<MenuItemProps> => {
	return (Array.isArray(items) ? items : []).filter((item) => {
		const hasSlot = !!item.slot

		if (!hasSlot) {
			return true
		} else if (allowSlotItemWithSubItems) {
			return slotItemWithSubItemClearance(item)
		}

		return false
	})
}
